import request from '@/utils/request'

// ========== AI对话消息 ==========
export function fetchChatMessageList (data) {
  return request.post('/pc/meihui/chatMessage/page', data)
}
export function deleteChatMessage (id) {
  return request.get(`/pc/meihui/chatMessage/delete/${id}`)
}
export function deleteChatMessageBatch (ids) {
  return request.get('/pc/meihui/chatMessage/delete/batch', { params: { ids } })
}

// ========== AI会话 ==========
export function fetchChatSessionList (data) {
  return request.post('/pc/meihui/chatSession/page', data)
}
export function deleteChatSession (id) {
  return request.get(`/pc/meihui/chatSession/delete/${id}`)
}
export function deleteChatSessionBatch (ids) {
  return request.get('/pc/meihui/chatSession/delete/batch', { params: { ids } })
}

// ========== 日记碎片 ==========
export function fetchDiaryFragmentList (data) {
  return request.post('/pc/meihui/diaryFragment/page', data)
}
export function deleteDiaryFragment (id) {
  return request.get(`/pc/meihui/diaryFragment/delete/${id}`)
}
export function deleteDiaryFragmentBatch (ids) {
  return request.get('/pc/meihui/diaryFragment/delete/batch', { params: { ids } })
}

// ========== 私密日记 ==========
export function fetchPrivateDiaryList (data) {
  return request.post('/pc/meihui/privateDiary/page', data)
}
export function createPrivateDiary (data) {
  return request.post('/pc/meihui/privateDiary/create', data)
}
export function updatePrivateDiary (data) {
  return request.post('/pc/meihui/privateDiary/updateById', data)
}
export function deletePrivateDiary (id) {
  return request.get(`/pc/meihui/privateDiary/delete/${id}`)
}
export function deletePrivateDiaryBatch (ids) {
  return request.get('/pc/meihui/privateDiary/delete/batch', { params: { ids } })
}

// ========== 觉察洞察 ==========
export function fetchInsightList (data) {
  return request.post('/pc/meihui/insight/page', data)
}
export function createInsight (data) {
  return request.post('/pc/meihui/insight/create', data)
}
export function updateInsight (data) {
  return request.post('/pc/meihui/insight/updateById', data)
}
export function deleteInsight (id) {
  return request.get(`/pc/meihui/insight/delete/${id}`)
}
export function deleteInsightBatch (ids) {
  return request.get('/pc/meihui/insight/delete/batch', { params: { ids } })
}

// ========== 分享手记 ==========
export function fetchShareList (data) {
  return request.post('/pc/meihui/share/page', data)
}
export function createShare (data) {
  return request.post('/pc/meihui/share/create', data)
}
export function updateShare (data) {
  return request.post('/pc/meihui/share/updateById', data)
}
export function deleteShare (id) {
  return request.get(`/pc/meihui/share/delete/${id}`)
}
export function deleteShareBatch (ids) {
  return request.get('/pc/meihui/share/delete/batch', { params: { ids } })
}

// ========== 海报模板 ==========
export function fetchPosterTemplateList (data) {
  return request.post('/pc/meihui/posterTemplate/page', data)
}
export function createPosterTemplate (data) {
  return request.post('/pc/meihui/posterTemplate/create', data)
}
export function importSharePosterTemplates (data) {
  return request.post('/pc/meihui/sharePosterTemplate/importByUrls', data)
}
export function updatePosterTemplate (data) {
  return request.post('/pc/meihui/posterTemplate/updateById', data)
}
export function deletePosterTemplate (id) {
  return request.get(`/pc/meihui/posterTemplate/delete/${id}`)
}
export function deletePosterTemplateBatch (ids) {
  return request.get('/pc/meihui/posterTemplate/delete/batch', { params: { ids } })
}

// ========== 模板配置 ==========
export function fetchTemplateConfigList (data) {
  return request.post('/pc/meihui/templateConfig/page', data)
}
export function createTemplateConfig (data) {
  return request.post('/pc/meihui/templateConfig/create', data)
}
export function updateTemplateConfig (data) {
  return request.post('/pc/meihui/templateConfig/updateById', data)
}
export function deleteTemplateConfig (id) {
  return request.get(`/pc/meihui/templateConfig/delete/${id}`)
}
export function deleteTemplateConfigBatch (ids) {
  return request.get('/pc/meihui/templateConfig/delete/batch', { params: { ids } })
}

// ========== 模板样式 ==========
export function fetchTemplateStyleList (data) {
  return request.post('/pc/meihui/templateStyle/page', data)
}
export function createTemplateStyle (data) {
  return request.post('/pc/meihui/templateStyle/create', data)
}
export function updateTemplateStyle (data) {
  return request.post('/pc/meihui/templateStyle/updateById', data)
}
export function deleteTemplateStyle (id) {
  return request.get(`/pc/meihui/templateStyle/delete/${id}`)
}
export function deleteTemplateStyleBatch (ids) {
  return request.get('/pc/meihui/templateStyle/delete/batch', { params: { ids } })
}

// ========== 模板组件 ==========
export function fetchTemplateComponentList (data) {
  return request.post('/pc/meihui/templateComponent/page', data)
}
export function createTemplateComponent (data) {
  return request.post('/pc/meihui/templateComponent/create', data)
}
export function updateTemplateComponent (data) {
  return request.post('/pc/meihui/templateComponent/updateById', data)
}
export function deleteTemplateComponent (id) {
  return request.get(`/pc/meihui/templateComponent/delete/${id}`)
}
export function deleteTemplateComponentBatch (ids) {
  return request.get('/pc/meihui/templateComponent/delete/batch', { params: { ids } })
}

// ========== 用户模板映射 ==========
export function fetchUserTemplateMappingList (data) {
  return request.post('/pc/meihui/userTemplateMapping/page', data)
}
export function createUserTemplateMapping (data) {
  return request.post('/pc/meihui/userTemplateMapping/create', data)
}
export function updateUserTemplateMapping (data) {
  return request.post('/pc/meihui/userTemplateMapping/updateById', data)
}
export function deleteUserTemplateMapping (id) {
  return request.get(`/pc/meihui/userTemplateMapping/delete/${id}`)
}
export function deleteUserTemplateMappingBatch (ids) {
  return request.get('/pc/meihui/userTemplateMapping/delete/batch', { params: { ids } })
}

// ========== 日记模板 ==========
export function fetchDiaryTemplateList (data) {
  return request.post('/pc/meihui/diaryTemplate/page', data)
}
export function createDiaryTemplate (data) {
  return request.post('/pc/meihui/diaryTemplate/create', data)
}
export function updateDiaryTemplate (data) {
  return request.post('/pc/meihui/diaryTemplate/updateById', data)
}
export function deleteDiaryTemplate (id) {
  return request.get(`/pc/meihui/diaryTemplate/delete/${id}`)
}
export function deleteDiaryTemplateBatch (ids) {
  return request.get('/pc/meihui/diaryTemplate/delete/batch', { params: { ids } })
}

// ========== 觉察模板 ==========
export function fetchInsightTemplateList (data) {
  return request.post('/pc/meihui/insightTemplate/page', data)
}
export function createInsightTemplate (data) {
  return request.post('/pc/meihui/insightTemplate/create', data)
}
export function updateInsightTemplate (data) {
  return request.post('/pc/meihui/insightTemplate/updateById', data)
}
export function deleteInsightTemplate (id) {
  return request.get(`/pc/meihui/insightTemplate/delete/${id}`)
}
export function deleteInsightTemplateBatch (ids) {
  return request.get('/pc/meihui/insightTemplate/delete/batch', { params: { ids } })
}

// ========== 手记模板 ==========
export function fetchShareTemplateList (data) {
  return request.post('/pc/meihui/shareTemplate/page', data)
}
export function createShareTemplate (data) {
  return request.post('/pc/meihui/shareTemplate/create', data)
}
export function updateShareTemplate (data) {
  return request.post('/pc/meihui/shareTemplate/updateById', data)
}
export function deleteShareTemplate (id) {
  return request.get(`/pc/meihui/shareTemplate/delete/${id}`)
}
export function deleteShareTemplateBatch (ids) {
  return request.get('/pc/meihui/shareTemplate/delete/batch', { params: { ids } })
}

// ========== 用户心情 ==========
export function fetchUserMoodList (data) {
  return request.post('/pc/meihui/userMood/page', data)
}
export function createUserMood (data) {
  return request.post('/pc/meihui/userMood/create', data)
}
export function updateUserMood (data) {
  return request.post('/pc/meihui/userMood/updateById', data)
}
export function deleteUserMood (id) {
  return request.get(`/pc/meihui/userMood/delete/${id}`)
}
export function deleteUserMoodBatch (ids) {
  return request.get('/pc/meihui/userMood/delete/batch', { params: { ids } })
}
